import axios from 'axios';
import authHeader from "@/service/AuthHeader";
import getEnvironment from "@/service/Environment";

const API_URL = getEnvironment().API_LOGGED_IN_URL + 'invitation';

export default class InvitationService {
    getAll() {
        return axios.get(API_URL + '/list', { headers: authHeader() });
    }

    accept(id) {
        return axios.put(API_URL + `/accept/${id}`, {}, { headers: authHeader() });
    }

    decline(id) {
        return axios.put(API_URL + `/decline/${id}`, {}, { headers: authHeader() });
    }

    delete(id) {
        return axios.delete(API_URL + `/delete/${id}`, { headers: authHeader() });
    }
}

